import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { AppModel } from '../models/AppModel';
import { Store } from '@ngrx/store';
import { State } from '../../state/app.reducer';
import { AppActions } from '../../actions';
import { environment } from '../../../environments/environment';
import logdna from '@logdna/browser';

@Injectable()
export class AppInitializerService {
  constructor(
    private readonly appService: AppService,
    private readonly store: Store<State>) { }

  getApplication(): Promise<AppModel> {

    return this.appService.getApp()
      .toPromise()
      .then((appModel: AppModel) => {
        if (!environment().development) {
          logdna.init(appModel.logDNAIngestionKey, {
            app: 'job-site',
            console: false,
            enableStacktrace: false,
            globalErrorHandlers: false,
            /* hostname: '[insert pod name]'*/
            tags: [environment().production ? 'prod' : 'dev'],
          }).addContext({
            InstanceId: appModel.instanceId.toString()
          });
        }

        this.store.dispatch(AppActions.initialized({ appModel }));
        return appModel;
      });
  }
}
